export const Icon = {
	ACCORDION: '100625',
	BUTTON: 'aC8ou51uob1J',
	COLUMNS: '52215',
	CTASection: '6916',
	DEFAULT: '87005',
	FORM: '2kp_j6sUhhNU',
	HEADER: '107431',
	HERO: '111028',
	IMAGE_TEXT_SECTION: 'cZzvUvXA72L5',
	LAYOUT: '62224',
	LINK: '85777',
	LOGOBAR: '5z2jE7WSK5w8',
	SECONDARY_HERO: '_0p37K42drxY',
	THANK_YOU: 'RZ686auD_5Wn',
} as const;

export type IconKey = keyof typeof Icon;
export type IconValue = (typeof Icon)[IconKey];

export const IconSet = {
	NEXT: 'Next',
	PREV: 'Previous',
	ERROR: 'Error',
	CLOSE: 'Close',
	PLAY: 'Play',
} as const;

export type IconSetKey = keyof typeof IconSet;
export type IconSetValue = (typeof IconSet)[IconSetKey];

export type IconMapKey = IconSetValue;
export type IconMap = Record<IconMapKey, JSX.Element>;
